import { useIntl } from 'react-intl';
import { Redirect } from 'react-router';
import { ID } from '@rossum/api-client';
import { Queue } from '@rossum/api-client/queues';
import { LinearProgress } from '@rossum/ui/material';
import { useGetRule } from '../../../rules/hooks/useGetRule';
import { RulePage, RulePageProps } from '../../../rules/rule-detail/RulePage';
import { QueueSettingsBreadcrumbs } from '../../components/QueueSettingsBreadcrumbs';

export const EditRulePage = ({
  ruleId,
  queue,
  parentPath,
  workspaceName,
}: Omit<RulePageProps, 'renderBreadcrumbs'> & {
  ruleId: ID;
  queue: Queue;
  workspaceName: string;
}) => {
  const intl = useIntl();
  const { data: rule, isLoading } = useGetRule(ruleId);

  return rule ? (
    <RulePage
      queue={queue}
      parentPath={parentPath}
      rule={rule}
      renderBreadcrumbs={breadcrumbs => (
        <QueueSettingsBreadcrumbs
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'features.queueSettings.rules.list.title',
              }),
              to: `${parentPath}/rules`,
            },
            ...breadcrumbs,
          ]}
          queue={queue}
          workspaceName={workspaceName}
        />
      )}
    />
  ) : isLoading ? (
    <LinearProgress />
  ) : (
    <Redirect to={`${parentPath}/rules`} />
  );
};
